import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { environment } from "../../../environments/environment";
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { CompanyInsightsService, ExportPayload, ExportRequest } from 'src/app/_services/company-insights.service';
import { Subscription, Subject } from 'rxjs';
import * as _ from 'underscore';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { HashService } from 'src/app/_services/hash.service';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { OpenaiService } from 'src/app/openai/openai.service';
import cjson from 'compressed-json';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';


declare var google;

@Component({
    selector: 'app-location-tab',
    templateUrl: './location-tab.component.html',
    styleUrls: ['./location-tab.component.scss'],
    standalone: false
})
export class LocationTabComponent implements OnInit {

  constructor(private fusionChartService: FusionChartsService, private personSearchService: PersonSearchService, private location: Location, private companyinsightsService: CompanyInsightsService, private localStorageService: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private hashService: HashService, private talentInsightsService: TalentInsightsService,     private openaiService: OpenaiService
    ) { }
  companyDetails: any;
  currentCompanyName: any;
  dataSourceWorkCountry: any[] = [];
  topLocations: any[] = [];
  locations: any = [];
  locationsData: any = [];
  @ViewChild('locationTbSort') locationTbSort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', 'recent_hires', '%Total', 'graph', 'job_doc_count', 'median_salary'];
  aggregatescount: number = 50;
  alternatecompanyNames: any[] = [];

  /** start index in page */
  start: number = 0;
  /**End index in page */
  end: number = 10;
  /**Number of items on each of page */
  pageSize: number = 10;
  /**Current page number */
  currentPage: number = 1;
  /**Total items */
  totalCount = 0;
  locationsubscription: Subscription;
  locationemptystate: Boolean = false;
  totalresultcount: any;
  locationsname: any
  locationSortArr: any = [];
  locationsdataAI: any
  /** Subscription var */
  subscriptions: Array<Subscription> = [];
  companyinsightsFilter: any ={};
  insightsExportSubscription: Subscription = null;

/**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "TopCities": "Top Locations",
    "TalentCount": "Talent Count",
    "1yrGrowth": "1 yr Growth",
    "%OfTotal": "% of Total",
    "DiversityRatio": "Diversity Ratio",
    "JobDemand": "Job Posts",
    "MedianSalary": "Median Salary"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  combinedAggregates: any;
  combinedIndustry: any;
  combinedSkills: any;
  combinedJobtitle: any;
  target_currency_rate: number = 1;
  target_fav_icon: string = 'fa-dollar-sign';
  target_currency_symbol: string = '$';

  currency: string;
  hasJobDemand: boolean = false;
hasMedianSalary: boolean = false;
currencyData: any[] = [];
filteredCurrencies: any[] = [];
selectedCurrency: any = null;
aiSuggestions: any = {};
filterData: any = {};

 sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  sliderPayload:any
hasJobListingAccess:any

  ngOnInit(): void {
    this.setCompanyDetails();
    this.fetchPageData();
    /**Fetch filter data after applying filters */
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
             const eventInfo = _methodDetails;

  // The actual current filter-panel state lives in the getter
  this.filterData = this.filterDataHandlerService.fetchFilterData;
       this.getCurrencyData()

    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.companyinsightsService.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if(requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
        this.hasJobListingAccess = this.localStorageService.getItem('hasjoblistingaccess')

  }

  setCompanyDetails() {
    this.companyDetails = this.companyinsightsService.fetchCompanyData;
    this.currentCompanyName = this?.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.currentCompanyName]) : [this.currentCompanyName];
  }

  fetchPageData() {
    this.getTopLocations();
    this.personSearchService.setCompanyInsightsFilterAI(this.companyDetails);

  }

  getTopLocations() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location-gender-recenthires";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyinsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
      const tempData = response?.data?.aggregations['location-gender-recenthires'];
      this.locationSortArr = tempData;
      this.formatLocationSortArray();

      this.totalCount = tempData.length;
      this.totalresultcount = response.data.totalresultscount

      this.locationemptystate = true;
      this.locationsname = _.pluck(this.locationSortArr, 'key');
      this.getCurrency();
      this.manualSort();
      this.getlocationsAIdata(this.locationSortArr);
    });
  }

  private formatLocationSortArray() {
    this.locationSortArr?.map(apiResponse => {
      if (apiResponse && apiResponse.gender && apiResponse.gender.length > 0) {
        const femalecount = this.getFemaleCount(apiResponse);
        const malecount = this.getMaleCount(apiResponse);
        const totalgendercount = femalecount + malecount;
        apiResponse.female = femalecount ? this.getdiversitypercentage(femalecount, totalgendercount) : 0;
        apiResponse.male = malecount ? this.getdiversitypercentage(malecount, totalgendercount) : 0;
      }
      apiResponse.totalpercentage = apiResponse.doc_count ? this.getlocationpercentage(apiResponse.doc_count) : 0;
      apiResponse.recenthires = apiResponse?.recenthires;
      return apiResponse;
    });
  }

  private getFemaleCount(apiResponse: any) {
    const femaleData = apiResponse?.gender?.find(x => x.key === "female");
    return femaleData?.doc_count || 0;
  }

  private getMaleCount(apiResponse: any) {
    const maleData = apiResponse?.gender?.find(x => x.key === "male");;
    return maleData?.doc_count || 0;
  }

  /**
   * fuction will mark the locations on google map
   * On the basis of data shown on each page
   */
  markMap() {
    const CharForworkCountry = [];
    CharForworkCountry.push(['Location', 'Professional count'])
    this.locationsData.forEach(x => {
      const dataObj = [`${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`, x.doc_count];
      CharForworkCountry.push(dataObj);
    });
    this.dataSourceWorkCountry = CharForworkCountry;
    setTimeout(() => {
      this.loadGoogleMap();
    });
  }

  manualSort() {
    this.reSortArr(this.locationTbSort);
  }

  reSortArr(sort: MatSort) {
    const tempData = this.locationSortArr;
    if (!this.hasSortSelection(sort)) {
      this.setDefaultLocationData(tempData);
      return;
    }
    this.setLocationSortData(tempData, sort);
    this.locationsData = this.locationSortArr.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
    this.locationsname = _.pluck(this.locationSortArr, 'key');
    this.markMap();
  }

  private hasSortSelection(sort: MatSort) {
    return sort && sort.active && sort.direction;
  }

  private setDefaultLocationData(tempData: any) {
    this.locationsData = tempData.slice(this.start, this.end);
    this.locations = new MatTableDataSource(this.locationsData);
    this.locations.sort = this.locationTbSort;
    this.markMap();
  }

  private setLocationSortData(tempData: any, sort: MatSort) {
    this.locationSortArr = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%Total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.male, b.male, isAsc);
        case 'recent_hires': return this.compare(a.recenthires, b.recenthires, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }


  loadGoogleMap() {
    function drawMarkersMap() {
      var data = google.visualization.arrayToDataTable(this.dataSourceWorkCountry);
      var options = {
        region: 'world',
        displayMode: 'markers',
        colorAxis: { colors: this.fusionChartService.LOCATION_COLOR_PALETTE }
      };
      const container = document.getElementById('workCountryChart');
      var chart = new google.visualization.GeoChart(container);
      chart.draw(data, options);
    }

    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  /**
   * Function set the start and end of aggreggate datat according to page number
   * @param index page number in pagination
   */
  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    this.manualSort();

  }

  /**
   * destroy subscriptions of filters
   */
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getlocationpercentage(value) {
    return ((value / this.totalresultcount) * 100).toFixed(2);
  }


  getdiversitypercentage(value, doc_count) {
    return ((value / doc_count) * 100).toFixed(0);
  }

  /**
     * Handel Redirection to person search listing
     * @param type
     * @param key
     */
  handelRedirection(type: string, key: string) {
      const redirectFilters: Partial<FilterParams> = {
        // Company context — always present
        companyid: this.companyDetails?.id,
        companyname: this.currentCompanyName,
        alternativecompanynames: this.alternatecompanyNames,

        // Read-only snapshot of the overview tab's OWN filter panel (person-search-filter
        // sidebar). Nested so it can never collide with the listing page's normal filters.
        insightsFilterData: this.filterData,
      };
    switch (type) {
      case 'location': redirectFilters['mandatorylocations'] = [key]; break;
      case 'recent_hires': {
        redirectFilters['mandatorylocations'] = [key];
        redirectFilters['recentcompanyhires'] = true;
        break;
      }
    }

  const uniqueKey = this.hashService.generateUniqueHash();
  localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

  const url = `/candidate-list?type=search&redirectSource=company-insights&key=${uniqueKey}`;
  window.open(url, '_blank');
  }

  getlocationsAIdata(data) {
    let locationsdata: any;
    locationsdata = data.map(x => {
      return {
        'Top Cities': x.key,
        'Talent Count': x.doc_count,
        '% of Total': x.totalpercentage + '%',
        'Male': x.male + '%',
        'Female': x.female + '%',
        'Recent Hires': x.recenthires,
        'Job Posts': x.job_doc_count ?? 0,
        ...(x.median_salary_max != null && { 'median salary offered max': x.median_salary_max }),
        ...(x.median_salary_min != null && { 'median salary offered min': x.median_salary_min }),
        ...(this.selectedCurrency?.target_currency && {'Salary currency': this.selectedCurrency?.target_currency})
      }
    });
    this.modifyCurrencyDataForAi(locationsdata);
    this.locationsdataAI = {
      locations: locationsdata
    }
    if(locationsdata.length == 0)
      this.locationsdataAI = null;
  }

  /**
   * Format currency data
   * @param aiData Already formatted ai data
   * @returns
   */
  modifyCurrencyDataForAi(aiData) {
    if (!aiData || !Array.isArray(aiData)) {
      return;
    }
    aiData.forEach(item => {
      if (item['median salary offered max']) {
        item['median salary offered max'] = item['median salary offered max'] * this.target_currency_rate;
      }
      if (item['median salary offered min']) {
        item['median salary offered min'] = item['median salary offered min'] * this.target_currency_rate;
      }
      if (this.selectedCurrency?.target_currency) {
        item['Salary currency'] = this.selectedCurrency?.target_currency
      }
    })
  }


  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if(requestData?.data?.currentTab !== 'location') return;

    this.tableHeaderName = [this.tableHeaderObj["TopCities"], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["1yrGrowth"], this.tableHeaderObj["%OfTotal"], 'Diversity Ratio (M | W)', this.tableHeaderObj["JobDemand"], this.tableHeaderObj["MedianSalary"]];
    const locationDataForExport = this.locationSortArr.map(location => {
      return {
        ...location,
        job_doc_count: location.job_doc_count || '—',
        median_salary: location.median_salary != 'N/A' ? location.median_salary : '—',
      }
    });

    const payloadForInsightsExport: ExportPayload = {
      tab: 'location',
      companydetails: this.companyDetails,
      totalresultcount: this.totalresultcount,
      chartdetails: this.dataSourceWorkCountry?.length ? [{ type: 'google', data: this.dataSourceWorkCountry }] : [],
      locationgender: this.locationSortArr,
      location: locationDataForExport,
      tableHeader: this.tableHeaderName,
      currencySymbol: this.target_currency_symbol
    }
    this.companyinsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

    getCombinedAggregates() {
     this.hasJobDemand = true;
     this.hasMedianSalary = true;
    this.locationSortArr = this.locationSortArr.map(location => {
    location.median_salary = "";
    location.confidence_score = "";
    location.job_doc_count = '';
    return location;
  });

    const request = this.aggService.getRequestWithFilters();
    request.aggregatetype = "jobs_base_aggregates";
    request.aggregatescount = 50;
    request.companyids = [this.companyDetails.id];
      this.personSearchService.getTotalAggs(request).subscribe(response => {
   //   this.locationAPiCalled = true;
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
       this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
    //  this.getJobsAggregates();
    });
  }

  getJobsAggregates() {
 this.aiSuggestions = this.localStorageService.getItem('companyaiSuggestions')
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'location-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations|| [],
      industries: aggReq?.industries|| [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      companyids: [this.companyDetails.id],
      excluded_functions: aggReq?.exclude_functions || [],
      excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],

    }
            this.sliderPayload = payload

        this.talentInsightsService.getJobsAggregates(payload).subscribe((response:any) => {
          const tempData = response?.data?.aggregations['location-median_salary'];
           this.hasJobDemand = false;
          this.hasMedianSalary = false;
          this.locationSortArr.map(location => {
            const medianSalaryData = tempData.find(item => item.key.toLowerCase().trim() === location.key.toLowerCase().trim());
            if(medianSalaryData) {
              if(this.target_fav_icon == 'fa-money-bill'){
              location.median_salary = medianSalaryData.median_salary_min.value ? `${this.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

              } else {
              location.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

              }
               location.median_salary_min = medianSalaryData.median_salary_min.value;
          location.median_salary_max = medianSalaryData.median_salary_max.value;
              location.confidence_score = medianSalaryData.confidence_score;
              location.job_doc_count = medianSalaryData?.job_demand?.doc_count || '';
            } else {
              location.median_salary = "N/A";
              location.confidence_score = "N/A";
              location.job_doc_count = '';
            }
            return location;
          });
          this.getlocationsAIdata(this.locationSortArr);
        })
      }

  formatNumber(number: number): string | number {
     if (!number) return 0;
    const country = this.localStorageService.getItem('companyCurrencyCountry');
    const currency = this.localStorageService.getItem('companyCurrency');
    if((country && country == 'india') || (currency && currency.toLowerCase() == 'inr')) {
        const absNum = Math.abs(number);

  if (absNum >= 1e7) {
    return (number / 1e7).toFixed(1) + 'Cr';
  }

  if (absNum >= 1e5) {
    return (number / 1e5).toFixed(1) + 'L';
  }

  if (absNum >= 1e3) {
    return (number / 1e3).toFixed(1) + 'K';
  }

  return number;
    } else {
    const suffixes = ['', 'K', 'M', 'B', 'T'];
    let index = 0;

    while (Math.abs(number) >= 1000 && index < suffixes.length - 1) {
      number /= 1000;
      index++;
    }

    return (number).toFixed(1) + suffixes[index];
    }

  }

getCurrency() {
  this.talentInsightsService.getCountryCurrency().subscribe((response:any) => {
    this.currencyData = response?.data;
    this.filteredCurrencies = this.currencyData.slice(0, 5);
    const currency = this.localStorageService.getItem('companyCurrency');
    if(currency) {
      const selectedCurrency = this.currencyData.find((x:any) => x.target_currency === currency);
      if(selectedCurrency) {
        this.selectedCurrency = selectedCurrency;
        this.target_currency_rate = selectedCurrency.rate;
        this.currency = selectedCurrency.target_currency;
        this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
        this.target_currency_symbol = selectedCurrency.target_currency_symbol;
      }
    }
    this.getJobsAggregates();
  })
}

onTypeAheadSearch(event: any) {
  const input = event.target.value.toLowerCase();
  this.filteredCurrencies = this.currencyData.filter(x=>x.target_currency.toLowerCase().includes(input));
  this.filteredCurrencies = this.filteredCurrencies.slice(0, 5);
}

selectedItem(currencyItem: any) {
  this.selectedCurrency = currencyItem;
  this.target_currency_rate = currencyItem.rate;
  this.currency = currencyItem.target_currency;
  this.target_fav_icon = currencyItem.target_currency_fav_icon;
  this.target_currency_symbol = currencyItem.target_currency_symbol;
   this.localStorageService.setItem('companyCurrency', this.currency);
    this.locationSortArr = this.locationSortArr.map(location => {
      if (this.target_fav_icon == 'fa-money-bill') {
        location.median_salary = location.median_salary_min ? `${this.currency} ${this.formatNumber((location.median_salary_min) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(location.median_salary_max * this.target_currency_rate)}` : "N/A";
      } else {
        location.median_salary = location.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((location.median_salary_min) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(location.median_salary_max * this.target_currency_rate)}` : "N/A";
      }

      return location;
    });
    this.getlocationsAIdata(this.locationSortArr);
}

clearCurrency() {
  this.selectedCurrency = null;
  this.currency = null;
  this.filteredCurrencies = this.currencyData.slice(0, 5);
}

getCurrencyData() {
  const filterData = this.filterDataHandlerService.fetchFilterData;
  if(filterData && filterData.locationSelectedList.length > 0) {
      const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext',''));
      const payload = {locations: locations}
      this.talentInsightsService.getLocationCurrency(payload).subscribe((res:any)=>{
        if(res.status === 'success' && res.data){
          this.localStorageService.setItem('companyCurrency', res.data.base_currency);
          this.localStorageService.setItem('companyCurrencyCountry', res.data.country_name);
          this.getJobtitleSkillSuggestions();
        }
      })
  } else {
    this.localStorageService.setItem('companyCurrency', 'USD');
    this.localStorageService.setItem('companyCurrencyCountry', null);

      this.getJobtitleSkillSuggestions();
  }
}

  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus(){
    return this.hasMedianSalary || this.hasJobDemand;
  }

  openJoblistSlider(value:any){
    // if(type == 'jobtitles'){
    //   Object.assign(this.titlesTabPayload, {mandatory_jobtitles:[value]})
    // }
    // if(type == 'functions'){
    //   Object.assign(this.titlesTabPayload, {mandatory_functions:[value]})
    // }
    // if(type == 'seniority'){
    //   Object.assign(this.titlesTabPayload, {mandatory_seniority:[value]})
    // }

     Object.assign(this.sliderPayload, {mandatory_locations:[value]})
      this.sendDataToSliderSubject.next(this.sliderPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
    }
  getJobtitleSkillSuggestions() {
    const aggReq = this.aggService.getRequestWithFilters();
    if ((aggReq?.preferredskills?.length > 0 || aggReq?.jobtitles?.length > 0) || (aggReq?.booleanquery != '*') || aggReq?.pastjobtitles?.length > 0) {
      const payload = {
        skills: aggReq.preferredskills,
        jobtitles: aggReq?.jobtitles,
        boolean: aggReq.booleanquery == "*" ? null : aggReq.booleanquery
      }

      this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe(async (res: any) => {
        const responseData = res.data;
        const titles = [...(responseData.suggestedjobtitles || [])];
        const skills = [...(responseData.suggestedskills || [])];
        const filterSuggestions = {
          jobtitles: titles,
          skills: skills
        }
        this.localStorageService.setItem('companyaiSuggestions', filterSuggestions);
        this.fetchPageData();


      })
    } else {
      this.localStorageService.setItem('companyaiSuggestions', null);
      this.fetchPageData();
    }
  }
  }

